import { Stack, Typography } from '@mui/material';

interface SnapshotSelectionEmptyStateProps {
  description: string;
  icon?: React.ReactNode;
}

export function SnapshotSelectionEmptyState(
  props: SnapshotSelectionEmptyStateProps
) {
  const { description, icon } = props;

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
      gap='12px'
    >
      {icon}
      <Typography align='center' maxWidth={'190px'} variant='body1'>
        {description}
      </Typography>
    </Stack>
  );
}
